var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.type,_vm._b({tag:"element",attrs:{"type":"group"}},'element',{ ..._vm.$props, ..._vm.$attrs },false),[_vm._l((_vm.$slots),function(_,slot){return [_vm._t(slot)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }